// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": () => import("D:\\projects\\gandalfTheBlue\\src\\templates\\blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-pages-404-js": () => import("D:\\projects\\gandalfTheBlue\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-confirm-js": () => import("D:\\projects\\gandalfTheBlue\\src\\pages\\confirm.js" /* webpackChunkName: "component---src-pages-confirm-js" */),
  "component---src-pages-index-js": () => import("D:\\projects\\gandalfTheBlue\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-thanks-js": () => import("D:\\projects\\gandalfTheBlue\\src\\pages\\thanks.js" /* webpackChunkName: "component---src-pages-thanks-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "D:\\projects\\gandalfTheBlue\\.cache\\data.json")

